import { browserHistory } from "react-router";
import archiveTeacher from 'controllers/teacher/archiveTeacher'
import unarchiveTeacher from 'controllers/teacher/unarchiveTeacher'
import inviteTeacher from 'controllers/teacher/inviteTeacher'
import {confirm} from 'util/confirm'
import {alert} from 'util/alert'
import {fetchTeacher} from './ducks'
import CreateTeacherModal from 'template/Modals/CreateTeacher'
import {userCan} from 'containers/__R';
import locale from './locale'
export default function(teacherState) {

  if (teacherState == 'archived') {
    return getArchivedTeacherTableSettings.call(this);
  }

  return getDefaultTableSettings.call(this);
}

function getDefaultTableSettings() {
  let TabComponent = this;
  let {dispatch, teacherState, getSubscription} = this.props
	return [
    {
      title: __('Invite', 'teacher'),
      onClick: ({trData: teacher})=>{
        confirm(__('Send Invitation To Teacher: {tname}?', 'teacher', {tname: teacher.tName}))
        .then(() => {
          inviteTeacher(teacher.id)
          .then((result) => {
            if(result.result == 'failure'){
              alert.fail(__('Invitation Failure: please enter a valid phone number', 'teacher'))
            } else {
              const schoolId = localStorage.getItem('schoolId')
              this.props.fetchTeacher({schoolId, amount_per_page: 25, current_page_number: 1}, teacherState)
            }
          })
        })
        .catch(() => {})
      },
      isDisabled: ({trData: teacher})=>{
        return (teacher.stState == 2 || !userCan('invite_teacher'))
			}
    },
    {
      title: __("Archive Teacher", locale),
      onClick: ({ trData: teacher })=>{
        confirm(__('Proceed to archive teacher?', locale), __("Archive Teacher", locale))
        .then(() => {
          archiveTeacher(teacher.id)
          .then((result) => {
            if(result.status == 'Archive failed'){
              alert.fail(__('Please exit all classes in order to archived teacher', locale))
            } else {
              const schoolId = localStorage.getItem('schoolId')
              getSubscription(schoolId);
              this.props.fetchTeacher({schoolId, amount_per_page: 25, current_page_number: 1}, teacherState)
            }
          })
        })
        .catch(() => {})
      },
      isDisabled: ()=>{
        return !userCan('archive_teacher_from_school')
      }
    }
  ]
}

// Specifically used for archived student table
function getArchivedTeacherTableSettings() {
  let TabComponent = this;
  const {dispatch, teacherState, gSubscription, getSubscription} = this.props
  const {is_valid, maximum_amount, existing_amount, saas_version} = gSubscription.result;
  const {maximum_teacher} = maximum_amount;
  const {teacher_amount} = existing_amount;
	return [
		{
			title: __('Restore', 'teacher'),
			onClick: ({ trData: teacher }) => {
        confirm(__('Proceed to unarchive teacher?', 'teacher'), __("Restore", "teacher"))
        .then(() => {
          if(is_valid && (saas_version === 1 || maximum_teacher===null || teacher_amount+1<=maximum_teacher)){
            unarchiveTeacher(teacher.id)
            .then((result) => {
              const schoolId = localStorage.getItem('schoolId')
              getSubscription(schoolId);
              this.props.fetchTeacher({schoolId, amount_per_page: 25, current_page_number: 1}, teacherState)
            })
          }else {
            alert.message(__('You are about go over the teacher limit, please upgrade to higher subscription plan to add more teachers', 'header'), __('Upgrade Subscription Plan', 'header'))
          }
        })
        .catch(() => {})
      },
      isDisabled: ()=>{
        return !userCan('recover_teacher_in_school')
      }
		},
	]
}



// WEBPACK FOOTER //
// ./src/containers/pages/Teacher/table-settings.js